import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EcoGlyph = /*#__PURE__*/createElement("g", {
  id: "eco"
}, /*#__PURE__*/createElement("path", {
  d: "M57.9,50.9c-4.8,0-8.5-3.3-8.5-8.8c0-5.6,3.7-9,8.8-9c5.1,0,8.5,3.6,8.5,8.8C66.7,48.1,62.2,50.9,57.9,50.9L57.9,50.9z M58,47.8c2.5,0,4.2-2.4,4.2-5.8c0-2.7-1.2-5.7-4.1-5.7c-3,0-4.3,3-4.3,5.8C53.8,45.3,55.5,47.8,58,47.8L58,47.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M47.6,50c-0.9,0.4-2.7,0.9-4.8,0.9c-5.3,0-8.8-3.4-8.8-8.7c0-5.1,3.5-9.1,9.5-9.1c1.6,0,3.2,0.3,4.2,0.8l-0.8,3.3 c-0.7-0.4-1.7-0.7-3.3-0.7c-3.3,0-5.3,2.4-5.2,5.5c0,3.5,2.3,5.5,5.2,5.5c1.5,0,2.6-0.3,3.4-0.7L47.6,50z"
}), /*#__PURE__*/createElement("path", {
  d: "M30.5,40h-8.9V47h9.9v3.5H17.3V26.9h13.7v3.5h-9.4v6.1h8.9V40z"
}));
const Eco = createSvg({
  name: 'eco',
  path: EcoGlyph
});

export default Eco;
export { EcoGlyph };
